import React, { PropsWithChildren, useEffect, useState } from 'react';
import { I18nProvider as LinguiI18nProvider } from '@lingui/react';
import { i18n } from 'utils/setupTranslations';
import { SamplesLanguages } from 'types/enums';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';
import { useAuthentication } from 'contexts/AuthenticationProvider/AuthenticationProvider';

export const I18nProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { isDAWPlugin } = useExecutionEnvironmentContext();
    const { isLoading, locale } = useAuthentication();
    const [isActivated, setIsActivated] = useState(false);

    useEffect(() => {
        if (isDAWPlugin) {
            i18n.activate(SamplesLanguages.EN);
            setIsActivated(true);
            return;
        }

        if (!isLoading && locale) {
            i18n.activate(locale);
            setIsActivated(true);
        }
    }, [isDAWPlugin, isLoading, locale]);

    // Only render when i18n is activated
    if (!isActivated) {
        return null;
    }

    return <LinguiI18nProvider i18n={i18n}>{children}</LinguiI18nProvider>;
};
